export enum BusinessType {
  CORPORATE = "CORPORATE",
  AGENCY = "AGENCY",
}

export type Business = {
  id: string;
  name: string;
  email: string;
  phone: string;
  businessType: BusinessType;
  createdBy: string;
  created: string;
};

export interface GET_BUSINESSES_API_RESPONSE {
  statusCode: number;
  message: string;
  data: QueryResult<Business>;
}

export interface GET_BUSINESS_API_RESPONSE {
  statusCode: number;
  message: string;
  data: Business;
}
